import { useRouter } from "next/router";

import SellerReviewsInfo from "@components/Seller/SellerReviews/SellerReviewsInfo";
import SellerReviewsChart from "@components/Seller/SellerReviews/SellerReviewsChart";
import Button from "@components/Button";

const SellerReviewsHeader = ({ reviewsSummary }) => {
  const router = useRouter();

  const userCanPostReview = () => {
    router.push("/cont/comenzi/");
  };
  return (
    <div className="flex flex-col md:flex-row md:items-center">
      <SellerReviewsInfo
        reviewsSummary={reviewsSummary}
        userCanPostReview={userCanPostReview}
      />
      <SellerReviewsChart reviewsSummary={reviewsSummary} />
      <div className="md:hidden mt-6">
        <Button
          title="Adauga recenzia ta"
          display="block"
          size="normal"
          onClick={() => userCanPostReview()}
        />
      </div>
    </div>
  );
};

export default SellerReviewsHeader;
